export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6475.2306234a.jpg";